import React, { Component } from "react";
import phoneIcon from "../assets/phone-solid.svg";

export default class Nav extends Component {
  render() {
    const { phone, logo } = this.props;

    return (
      <nav>
        <div className="flex-nav">
          <div className="logo">
            <img src={logo} alt="First Federal Wisconsin" />
          </div>
          <div className="contact-us">
            <a
              target="_blank"
              rel="noreferrer nooopener"
              href={"tel:262-542-4448"}>
              <img src={phoneIcon} alt="Call Now" />
              262-542-4448
            </a>
          </div>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Nav.js